const format = (endpoint: string) =>
  `${process.env.REACT_APP_BASE_URL}/${endpoint}`;

const endpoints = {
  login: format("login"),
  merge: {
    index: format("admin/merge/"),
    car: format("admin/merge/car/"),
    submit: format("admin/merge/submit/"),
    sync: {
      brand: format("admin/merge/sync/brand/"),
      part: format("admin/merge/sync/part/"),
    },
    product: format("admin/merge/product/"),
  },
  address: {
    index: format("admin/address/"),
    basic: format("admin/address/basic/"),
    states: format("address/states/"),
  },
  user: {
    index: format("admin/user/"),
    cars: format("admin/user/cars/"),
    basic: format("admin/user/basic/"),
    single: format("admin/user/single/"),
    access: format("admin/user/access/"),
  },
  access: {
    index: format("admin/access/"),
    basic: format("admin/access/basic/"),
    single: format("admin/access/single/"),
  },
  discount: {
    index: format("admin/discount/"),
    basic: format("admin/discount/basic/"),
    single: format("admin/discount/single/"),
  },
  role: {
    index: format("admin/role/"),
    basic: format("admin/role/basic/"),
    single: format("admin/role/single/"),
  },
  category: {
    index: format("admin/category/"),
    old: format("admin/category/old/"),
    single: format("admin/category/single/"),
    basic: format("admin/category/basic/"),
    medias: format("admin/category/medias/"),
  },
  tag: {
    index: format("admin/tag/"),
    single: format("admin/tag/"),
    basic: format("admin/tag/basic/"),
    medias: format("admin/tag/medias/"),
  },
  menu: {
    index: format("admin/menu/"),
    single: format("admin/menu/"),
    basic: format("admin/menu/basic/"),
    medias: format("admin/menu/medias/"),
  },
  order: {
    index: format("admin/order/"),
    basic: format("admin/order/basic/"),
    factor: format("admin/order/factor/"),
    products: format("admin/order/products/"),
    delivery: format("admin/order/delivery/"),
    discount: format("admin/order/discount/"),
    payment: format("admin/order/payment/"),
    callPrice: format("admin/order/callPrice/"),
    status: format("admin/order/status/"),
  },
  orderProduct: {
    index: format("admin/orderProduct/"),
    single: format("admin/orderProduct/single/"),
    variants: format("admin/orderProduct/variant/"),
    buy: format("admin/orderProduct/buy/"),
    buyer: format("admin/orderProduct/buyer/"),
    update: format("admin/orderProduct/update/"),
    review: format("admin/orderProduct/review/"),
  },
  product: {
    single: format("admin/product/single/"),
    basic: format("admin/product/basic/"),
    index: format("admin/product/"),
    price: format("admin/product/price/"),
    specifics: format("admin/product/specifics/"),
    attributes: format("admin/product/attributes/"),
    fitFors: format("admin/product/fitFors/"),
    redirect: format("admin/product/redirect/"),
    relations: format("admin/product/relations/"),
    medias: format("admin/product/media/"),
    search: format("admin/product/search/"),
    guarantees: format("admin/product/guarantees/"),
    faqs: format("admin/product/faqs/"),
  },
  guaranteeCompany: {
    index: format("admin/guaranteeCompany"),
    single: format("admin/guaranteeCompany/single/"),
    basic: format("admin/guaranteeCompany/basic/"),
  },
  part: {
    index: format("admin/part/"),
    old: format("admin/part/old/"),
    single: format("admin/part/single/"),
    basic: format("admin/part/basic/"),
    specific: format("admin/part/specifics/"),
  },
  landing: {
    index: format("admin/landing/"),
    carLanding: format("admin/landing/carLanding/"),
    carLandingBasic: format("admin/landing/carLanding/basic/"),
    single: format("admin/landing/single/"),
    basic: format("admin/landing/basic/"),
    banners: format("admin/landing/banners/"),
    posts: format("admin/landing/posts/"),
    brands: format("admin/landing/brands/"),
    productGroups: format("admin/landing/productGroups/"),
  },
  brand: {
    index: format("admin/brand/"),
    basic: format("admin/brand/basic/"),
    single: format("admin/brand/single/"),
    medias: format("admin/brand/medias/"),
  },
  deliveryMethod: {
    index: format("admin/deliveryMethod/"),
    basic: format("admin/deliveryMethod/basic/"),
    single: format("admin/deliveryMethod/single/"),
  },
  tapin: {
    status: format("admin/tapin/status"),
    states: format("admin/tapin/states"),
    boxes: format("admin/tapin/boxes"),
    shops: format("admin/tapin/shops"),
    syncLocations: format("admin/tapin/sync-locations"),
    quote: format("admin/tapin/quote/"),
    register: format("admin/tapin/register/"),
    track: format("admin/tapin/track/"),
    changeStatus: format("admin/tapin/change-status/"),
  },
  paymentMethod: {
    index: format("admin/paymentMethod/"),
    basic: format("admin/paymentMethod/basic/"),
    single: format("admin/paymentMethod/single/"),
  },
  page: {
    index: format("admin/page/"),
    basic: format("admin/page/basic/"),
    single: format("admin/page/single/"),
    banners: format("admin/page/banners/"),
    brands: format("admin/page/brands/"),
    posts: format("admin/page/posts/"),
    productGroups: format("admin/page/productGroups/"),
  },
  color: {
    index: format("admin/color/"),
    basic: format("admin/color/basic/"),
    single: format("admin/color/single/"),
  },
  specificValue: {
    index: format("admin/specificValue/"),
    old: format("admin/specificValue/old/"),
  },
  car: {
    index: format("admin/car/"),
    basic: format("admin/car/basic/"),
  },
  store: {
    index: format("admin/store/"),
    basic: format("admin/store/basic/"),
  },
  variant: {
    index: format("admin/variant/"),
  },
  year: format("admin/year/"),
  specific: {
    index: format("admin/specific/"),
    single: format("admin/specific/single/"),
    old: format("admin/specific/old/"),
    basic: format("admin/specific/basic/"),
    value: format("admin/specific/value/"),
  },
  logs: {
    search: format("log/search"),
    stats: format("log/stats"),
  },
  activityLog: format("admin/activityLog"),
  dashboard: format("admin/dashboard"),
  media: {
    editor: format("admin/media/editor"),
  },
  setting: {
    index: format("admin/setting"),
    topBanner: format("admin/setting/topBanner"),
  },
  bulk: {
    count: format("admin/bulk/count"),
    price: format("admin/bulk/price"),
    revert: (id: number) => format(`admin/bulk/price/${id}/revert`),
    status: format("admin/bulk/status"),
  },
};
export default endpoints;
